import React from 'react';
import { render, screen } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import ConfigProvider from 'components/ConfigProvider';

import EditUser from './EditUser';
import { userFixture } from './fixtures';

const renderPage = (props = {}) =>
  render(
    <ConfigProvider>
      <EditUser
        currentPath="/management/users"
        currentUser={{
          email: 'jane@decisiv.com',
          logoutPath: '/logout',
          name: 'Jane Smith',
        }}
        user={userFixture()}
        usersPath="/management/users"
        {...props}
      />
    </ConfigProvider>,
  );

describe('management/EditUser', () => {
  it('renders the form inside the management shell', () => {
    renderPage();

    expect(
      screen.getByRole('heading', { name: 'Edit Abe Martinez' }),
    ).toBeInTheDocument();
    expect(screen.getByLabelText(/First Name/)).toHaveValue('Abe');
  });

  it('renders the shell nav alongside it', () => {
    renderPage();

    expect(screen.getByRole('link', { name: /Users/ })).toBeInTheDocument();
  });

  describe('the breadcrumb', () => {
    it('links back to the list', () => {
      renderPage();

      expect(screen.getByRole('link', { name: 'Users' })).toHaveAttribute(
        'href',
        '/management/users',
      );
    });

    it('names the page the admin is on', () => {
      renderPage();

      expect(
        screen.getByRole('navigation', { name: 'Breadcrumb' }),
      ).toHaveTextContent('Edit User');
    });

    // The reason it is mounted here rather than in the header it sits above. KeyDS
    // Breadcrumbs renders Link, which creates its styled component inside a useMemo:
    // re-render it on the React 16 pins and the hook count no longer matches, taking
    // the whole page down in areHookInputsEqual. Typing is what re-renders the form,
    // so typing is what this has to survive — and it only does while the breadcrumb
    // stays out of the subtree that holds the form's state.
    it('survives the form re-rendering as the admin types', () => {
      renderPage({ canEdit: true });

      userEvent.type(screen.getByLabelText(/First Name/), 'xyz');

      // The crash this guards against throws during the second render, so reaching
      // an assertion at all is most of the point. Length rather than the value:
      // jsdom leaves the caret where it was between the controlled re-renders of a
      // KeyDS TextField, so the three characters land out of order ("Abeyzx"). That
      // predates this test and is not what it is about.
      expect(screen.getByLabelText(/First Name/).value).toHaveLength(6);
      expect(screen.getByRole('link', { name: 'Users' })).toBeInTheDocument();
      expect(
        screen.getByRole('navigation', { name: 'Breadcrumb' }),
      ).toBeInTheDocument();
    });
  });

  // canEdit defaults to false, so a payload that omits it renders read-only rather
  // than offering a save that would 403.
  it('is read-only unless told otherwise', () => {
    renderPage();

    expect(
      screen.queryByRole('button', { name: /Save Changes/ }),
    ).not.toBeInTheDocument();
  });

  it('offers the save controls when the viewer may edit', () => {
    renderPage({ canEdit: true });

    expect(
      screen.getByRole('button', { name: /Save Changes/ }),
    ).toBeInTheDocument();
  });
});
